import React, { Component } from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  Link,
  EditButton,
  Filter,
  TextInput,
  CardActions,
  ExportButton,
  SelectInput,
  CreateButton,
  ReferenceInput,
  showNotification,
  refreshView,
} from "react-admin";
import { connect } from "react-redux";
import rowStyle from "./components/rowStyle";
import ExcelImportDialog from "./components/excel-import-dialog";

const ProjectsActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total,
  showNotification,
  refreshView,
}) => {
  return (
    <CardActions>
      {bulkActions &&
        React.cloneElement(bulkActions, {
          basePath,
          filterValues,
          resource,
          selectedIds,
          onUnselectItems,
        })}
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}
      <CreateButton basePath={basePath} />
      <ExportButton
        disabled={total === 0}
        resource={resource}
        sort={currentSort}
        filter={filterValues}
        exporter={exporter}
      />
      <ExcelImportDialog
        showNotification={showNotification}
        refreshView={refreshView}
      />
    </CardActions>
  );
};

const ConnectedProjectsActions = connect(null, {
  showNotification,
  refreshView,
})(ProjectsActions);

const statuses = [
  { value: "Activo", description: "Activo" },
  { value: "Inactivo", description: "Inactivo" },
];

const ProjectFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Nombre del proyecto" source="name" />
    <TextInput label="Nombre de constructora" source="construction_name" />
    <ReferenceInput
      label="Ciudad"
      source="city_id"
      reference="locations-cities"
    >
      <SelectInput source="name" />
    </ReferenceInput>
    <SelectInput
      choices={statuses}
      source="status"
      label="Estado"
      optionText="description"
      optionValue="value"
    />
  </Filter>
);

const ConstructionCompaniesField = ({ record, ...rest }) => {
  return record && record.construction_company ? (
    <Link to={`/construction-companies/${record.construction_company_id}`}>
      <TextField
        source="construction_company.name"
        record={record}
        {...rest}
        style={{ color: "#3f51b5" }}
      />
    </Link>
  ) : (
    "Sin Asignar"
  );
};

const AdministarionField = ({ record }) => {
  return record.edited_by == "No editado"
    ? "Coordenada Urbana"
    : record.edited_by == "Administrador"
    ? "Administador"
    : "Constructora";
};

const EditedByField = ({ record }) => {
  return record.created_from == "lote excel" ? "Coordenada Urbana" : "Unitario";
};

const ProjectsSalesCompany = ({ record }) => {
  return record.selling_company
    ? `${record.selling_company.name}`
    : "No asignada";
};
export default class ProjectList extends Component {
  render() {
    return (
      <List
        {...this.props}
        title="Listado de proyectos"
        filters={<ProjectFilter />}
        actions={<ConnectedProjectsActions />}
      >
        <Datagrid rowStyle={rowStyle}>
          <TextField source="id" label="Id" />
          <TextField source="name" label="Nombre" />
          <ReferenceField
            label="Ciudad"
            source="city_id"
            reference="locations-cities"
          >
            <TextField source="name" />
          </ReferenceField>
          <ConstructionCompaniesField label="Constructora" />
          <ProjectsSalesCompany label="Vendedora" />
          <EditedByField label="Creado por" />
          {/* <TextField source="edited_by" label="Editado por" /> */}
          <TextField source="status" label="Estado" />
          <TextField source="priority" label="Destacado" />
          <AdministarionField label="Sincronizado por" />
          <EditButton label="" /* className="btn-edit" */ />
        </Datagrid>
      </List>
    );
  }
}
